import styled, { css } from 'styled-components'

interface DividerSectionProps {
  adjacent?: boolean
  constrained?: boolean
}

const DividerSection = styled.section<DividerSectionProps>`
  margin-bottom: 120px;
  ${({ adjacent }) =>
    adjacent
      ? css`
          margin-bottom: 60px;
        `
      : null};
`

export default DividerSection
